module.exports = __webpack_public_path__ + "static/sport/left-pic.5af2ed2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/left-pic.webp
// module id = drjC
// module chunks = 0